import React, {Component} from "react";
import {connect} from "react-redux";
import {NavLink} from "react-router-dom";
import KeyVal from "../shared/KeyVal";

class Receipt extends Component {
    constructor(props) {
        super(props);
        this.state = {}
    }

    componentDidMount() {
        const urlParams = new URLSearchParams(window.location.search);

        this.setState({
            inApp: urlParams.get('inApp') === 'true',
            status: urlParams.get('status'),
            amount: urlParams.get('amount'),
            tracking: urlParams.get('tracking'),
        })
    }

    render() {
        return (
            <div className="main-app ">
                <div className="text-center">
                    <div className="text-center mt-5 mb-5">
                        <i style={{fontSize:'48px'}} className={' p-3 ' + (this.state.status === 'success' ? 'icon-checkmark-outline green-text' : 'icon-close-outline red-color' )}/>
                    </div>
                    <div className="text-center mt-4">
                        <span>{this.state.status === 'success' ? 'Payment was successful' : (this.state.status === 'failed' ? 'The payment is failed, please try again or contact the support' : 'The user has canceled the payment')}</span>
                    </div>
                    <div className="p-4 border-bottom">
                        <KeyVal
                            name="Invoice Number"
                            value={this.state.tracking ? this.state.tracking : ' - '}
                        />
                    </div>
                    <div className="mt-5 text-center">
                        {this.state.inApp ? <a href="tutorfest://tutorfest.com" className="waves-effect waves-light btn white no-uppercase shadow-black">
                            <span>Back To App</span>
                        </a> : <NavLink to="/hom" className="waves-effect waves-light btn white no-uppercase shadow-black">
                            <span>Back To Home</span>
                        </NavLink>}
                    </div>
                </div>
            </div>
        );
    }
}

const mapDispatchToProps = (dispatch) => {
    return {
        dispatch: dispatch
    }
}

const mapStateToProps = (state) => {
    return {}
}

export default connect(mapStateToProps, mapDispatchToProps)(Receipt)
